import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import _ from 'lodash';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import { handleApiRequest } from '../../api';

import useApiError from '../../hook/useApiError';
import useUserAuth from '../../hook/useUserAuth';
import useGlobalStatus from '../../hook/useGlobalStatus';

import { PAGE } from '../../constants/url';

import AlertMsg from '../../components/alert/AlertMsg';
import Loading from '../../components/loading/Loading';
import ModalComponent from '../../components/modal/ModalComponent';
import { MODAL_CONTENT } from '../../components/modal/constants';

import WorkListTable from './WorkListTable';
import { TooltipStyle } from './workListStyle';
import { validateForm } from './constants';

import { formatDate2, compareAscDate } from '../../utils/date';
import { tableData } from '../../components/table/tableData';
import { SpanTxtStyle } from './workListStyle';

import {
  ListAltIcon,
  AddIcon,
  RefreshIcon,
  ErrorOutlineIcon
} from '../../components/customStyles/images';
import theme from '../../theme';

const WorkList = (props) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { handleApiErrorStatus } = useApiError();
  const { userAuth, setUserAuth, authStatusMsg, setAuthStatusMsg } = useUserAuth();
  const { handleAlertMsgSettings, isModalOpen, setIsModalOpen, editMode, setEditMode, modalData, setModalData, modalContent, setModalContent } = useGlobalStatus();
  const [resultData, setResultData] = useState([]);
  const [workListLimit, setWorkListLimit] = useState(1000);
  const [isLoading, setIsLoading] = useState(true);
  const [inputErrorMsg, setInputErrorMsg] = useState({});

  useEffect(() => {
    if (!isModalOpen) {
      navigate(PAGE.worklist.path);
      setInputErrorMsg({});
    }
  }, [isModalOpen])

  const fetchWorkList = () => {
    setIsLoading(true);
    handleApiRequest('getClientWorkList', `limit=${workListLimit}`)
      .then(res => {
        if (res.status === 200) {
          setResultData(res.data);

        } else {
          handleApiErrorStatus(res);
        }

        setIsLoading(false);
      })
  }

  useEffect(() => {
    fetchWorkList();
  }, []);

  const getClientList = () => {
    setIsLoading(true);
    handleApiRequest('getClientList')
      .then(res => {
        if (res.status === 200) {
          setModalData(res.data);
          setEditMode(false);
          setIsModalOpen(true);
          setModalContent(MODAL_CONTENT['createClientWork']);
          navigate(PAGE.creatework.path);

        } else {
          handleApiErrorStatus(res);
        }

        setIsLoading(false);
      })
  }

  const createWork = (data) => {
    const { isError, errorMsg } = validateForm(data);
    const checkDate = compareAscDate(data.start_date, data.end_date);

    if (checkDate === 1) {
      setInputErrorMsg(prev => ({ ...prev, check_date: true }))
    } else {
      setInputErrorMsg(prev => ({ ...prev, check_date: false }))
    }

    if (!isError) {
      setInputErrorMsg(prev => ({
        ...prev,
        client_select: false,
        start_date: false,
        end_date: false
      }))
    } else {
      setInputErrorMsg(prev => ({ ...prev, ...errorMsg }));
    }

    if (checkDate === 1 || isError) return;

    setIsLoading(true);

    const startDate = formatDate2(data.start_date);
    const endDate = formatDate2(data.end_date);

    const param = `start_date=${startDate}&end_date=${endDate}`;

    const requestData = {
      param: param,
      body: data.client_select
    }

    handleApiRequest('createClientWork', requestData)
      .then(res => {
        if (res.status === 200) {
          setIsModalOpen(false);
          handleAlertMsgSettings(true, {
            msg: '已建立工作'
          });
          navigate(PAGE.worklist.path);
          fetchWorkList();
        } else {
          handleApiErrorStatus(res);
        }

        setIsLoading(false);
      })
  }

  const deleteWork = (data) => {
    setIsLoading(true);
    const requestString = `job_id=${data.job_id}`;

    handleApiRequest('deleteWork', requestString)
      .then(res => {
        if (res.status === 200) {
          setIsModalOpen(false);
          handleAlertMsgSettings(true, {
            msg: '已刪除工作'
          });
          setIsLoading(false);
        } else {
          handleApiErrorStatus(res);
        }
      })
  }

  const handleTableAction = (e, { id, data }) => {
    if (id === 'delete') {
      setModalData(data);
      setEditMode(false);
      setIsModalOpen(true);
      setModalContent(MODAL_CONTENT['deleteWork']);
    }
  }

  const handleModalSubmit = (data, type) => {
    if (type === 'creatWork') {
      createWork(data);
    } else if (type === 'deleteWork') {
      deleteWork(data);
    }
  }

  return (
    <>
      <Box>
        <Stack variant='between-center' mt={3} mb={1}>
          <Stack variant='start-center'>
            <ListAltIcon variant='lg_30' />
            <Typography variant="h2" ml={1}>工作列表</Typography>
          </Stack>
          {/* <Stack>
            <Box mr={1}>
              <Button
                variant="title"
                onClick={() => {
                  navigate(PAGE.accountlist.path);
                }}
              >
                <ListAltIcon variant='lg_30' />
                <Typography
                  sx={{
                    display: {
                      sm: 'inline-block',
                      xs: 'none'
                    },
                  }}
                >
                  工作列表
                </Typography>
              </Button>
            </Box>

            <Box>
              <Button
                variant="title-action"
                onClick={() => {
                  navigate(PAGE.worklist.path);
                }}
              >
                <ListAltIcon variant='lg_30' />
                <Typography
                  sx={{
                    display: {
                      sm: 'inline-block',
                      xs: 'none'
                    },
                  }}
                >
                  工作列表v2
                </Typography>
              </Button>
            </Box>
          </Stack> */}

          <Stack>
            <Box mr={1}>
              <Button
                variant="fill-main"
                onClick={getClientList}
              >
                <AddIcon />
                <Typography
                  sx={{
                    display: {
                      sm: 'inline-block',
                      xs: 'none'
                    },
                    minWidth: '70px'
                  }}
                >
                  建立工作
                </Typography>
              </Button>
            </Box>

            <TooltipStyle arrow title="重新整理">
              <Button
                variant="fill-main-light"
                onClick={fetchWorkList}
              >
                <RefreshIcon />
              </Button>
            </TooltipStyle>
          </Stack>
        </Stack>

        <Stack variant='start-center' mb={1} style={{ color: theme.palette.grey.w600 }}>
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
              marginTop: '4px'
            }}
          >
            <ErrorOutlineIcon />
          </Box>

          <Typography variant='h6' ml={1}>只需輸入客戶<SpanTxtStyle>某一個廣告帳號編號（CID）</SpanTxtStyle>和日期區間，系統會自動更新該客戶<SpanTxtStyle>全部BQ表格全部廣告帳號</SpanTxtStyle>在該日期區間的資料。</Typography>
        </Stack>

        <WorkListTable
          resultData={resultData}
          isLoading={isLoading}
          handleTableAction={handleTableAction}
        />

      </Box>

      <ModalComponent
        isLoading={isLoading}
        handleModalSubmit={handleModalSubmit}
        inputErrorMsg={inputErrorMsg}
        setInputErrorMsg={setInputErrorMsg}
      />

      <AlertMsg />

      <Loading
        isLoading={isLoading}
        variant="inside"
      />
    </>
  )
}

export default WorkList;